function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

module.exports = _nonIterableRest;


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime-corejs2/helpers/nonIterableRest.js
// module id = 239
// module chunks = 1